import { CircularProgress } from "@mui/material";
// @ts-ignore
import TranslationWrapper from "../TranslationWrapper/TranslationWrapper";
import React from "react";
// @ts-ignore
import Button from "../CustomButtons/Button";

export default function SaveButton({ disabled, isValid, isSubmitting, onClick }) {
  return (
    <Button color={isValid ? "success" : "danger"} disabled={disabled} onClick={onClick}>
      {isSubmitting ? (
        <>
          <CircularProgress size={18} />
          <TranslationWrapper tDefault={"Bezig"} tKey={"global.savebutton.bezig.text"} />
          ...
        </>
      ) : (
        <TranslationWrapper tDefault={"Opslaan"} tKey={"global.jamezzForm.savebutton.text"} />
      )}
    </Button>
  );
}
